








import Vue from "vue";
import ItemListTiles from "./components/ItemListTiles.vue";

export default Vue.extend({
  name: "IdeasListApp",
  props: {
    //This prop is meant only to pass further to list component (ItemListTiles).
    //This component wrapper is only used to wrap list component in base tag
    //and components (add style workaround for Vuetify and base v-app component from Vuetify)
    listData: {
      type: Object,
      required: true
    }
  },
  components: {
    ItemListTiles
  }
});
